import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  HStack,
  Icon,
  IconButton,
  Table,
  Image,
  Button,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Switch,
  Tr,
  useClipboard,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { FiEdit2, FiTrash2, FiCopy, FiX } from "react-icons/fi";
import { KYDAffiliate } from "@common/interfaces/KYDEvent";

const AffiliateRow = ({
  affiliate,
  onEdit,
  onDelete,
  loading,
  isDisabled = false,
  readOnly = false,
}: {
  affiliate: KYDAffiliate;
  onEdit: (affiliate: KYDAffiliate) => void;
  onDelete: (affiliate: KYDAffiliate) => void;
  isDisabled?: boolean;
  readOnly?: boolean;
  loading: any;
}) => {
  const { onCopy } = useClipboard(affiliate.url);
  const toast = useToast();
  return (
    <Tr key={affiliate.id}>
      <Td>
        <Text fontWeight="medium">{affiliate.name}</Text>
      </Td>
      <Td>
        <Button
          onClick={() => {
            onCopy();
            toast({
              title: "✅ Link copied",
              status: "success",
              duration: 5000,
              isClosable: true,
            });
          }}
          rightIcon={<FiCopy />}
          variant={"outline"}
        >
          {affiliate.url.split("https://").pop()}
        </Button>
      </Td>
      <Td>
        <Text fontWeight="medium">{affiliate.display_clicks}</Text>
      </Td>
      <Td>
        <Text fontWeight="medium">{affiliate.display_revenue}</Text>
      </Td>
      <Td px={0}>
        <HStack spacing="1">
          {readOnly || !affiliate.editable ? null : (
            <IconButton
              isDisabled={loading["blocking"] || isDisabled}
              onClick={() => onEdit(affiliate)}
              icon={<FiEdit2 fontSize="1.25rem" />}
              variant="ghost"
              aria-label="Edit affiliate"
            />
          )}
        </HStack>
      </Td>
      <Td px={0}>
        <HStack spacing="1">
          {readOnly || !affiliate.editable ? null : (
            <IconButton
              isDisabled={loading["blocking"] || isDisabled}
              onClick={() => onDelete(affiliate)}
              icon={<FiX fontSize="1.25rem" />}
              variant="ghost"
              colorScheme="red"
              aria-label="Delete affiliate"
            />
          )}
        </HStack>
      </Td>
    </Tr>
  );
};
export const AffiliatesTable = ({
  affiliates,
  onEdit,
  onDelete,
  loading,
  readOnly = false,
  isDisabled = false,
  ...props
}: {
  affiliates: KYDAffiliate[];
  onEdit: (affiliate: KYDAffiliate) => void;
  onDelete: (affiliate: KYDAffiliate) => void;
  isDisabled?: boolean;
  readOnly?: boolean;
  loading: any;
}) => {
  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Link</Th>
          <Th>Clicks</Th>
          <Th>Revenue</Th>
          <Th px={0}></Th>
          <Th px={0}></Th>
        </Tr>
      </Thead>
      <Tbody>
        {affiliates.map((affiliate: KYDAffiliate) => (
          <AffiliateRow
            readOnly={readOnly}
            key={affiliate.id}
            affiliate={affiliate}
            onEdit={onEdit}
            isDisabled={isDisabled}
            onDelete={onDelete}
            loading={loading}
          />
        ))}
      </Tbody>
    </Table>
  );
};
